import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "agent";
const keys = addTranslations(RESOURCE_NAME, {
    breadcrumb_home: {
        en: "AI Tools Beta",
        fr: "Outils IA Beta",
    },
    breadcrumb_cdpExpert: {
        en: "CDP coach",
        fr: "Coach CDP",
    },
    breadcrumb_documentReviewer: {
        en: "Document reviewer",
        fr: "Revue de document",
    },
    breadcrumb_fastAnswer: {
        en: "Ask a question about your Ditto data",
        fr: "Posez une question sur vos données Ditto",
    },
    breadcrumb_evsExpert: {
        en: "Ecovadis coach",
        fr: "Coach Ecovadis",
    },
});

export function useAgentTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys}
}